import React, { useEffect, useState } from "react"
import { Button, Nav } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { withRouter } from "react-router"
import { Link } from "react-router-dom"

import styled from "styled-components"
import { fetchUser, removeUser, updateUser } from "../app/actions"
import AddEditUserModal from "./AddEditUserModal"
import UserTenantConnections from "./UserTenantConnections"

const TabContent = styled.div`
    padding-top: 2em;
`

const UserSummary = styled.div`
    padding: 1em;
    background: #e6e6e6;
    margin-top: 1em;
    margin-bottom: 1em;
    border-radius: 1em;
`

const ButtonBar = styled.div`
    display: flex;
    justify-content: space-between;
`

const InfoLabel = styled.span`
    width: 100px;
    display: inline-block;
    color: darkgrey;
    white-space: nowrap;
`

const RightInfoLabel = styled(InfoLabel)`
    width: 60px;
`

const UserSummaryHeader = styled.div`
    display: flex;
    justify-content: space-between;
`

const UserView = ({match, history}) => {
    const [showAddEditModal, setShowAddEditModal] = useState(false)

    const user = useSelector(store => store.app.user)
    const fetchingUser = useSelector(store => store.app.fetchingUser)
    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(fetchUser(match.params.userId))
    },[])

    const hideAddEditModal = () => {
        setShowAddEditModal(false)
    }

    const handleAddEditSave = (user) => {
        if(user.id) {
            dispatch(updateUser(user.id, user.FirstName, user.LastName, user.Email, user.MobileNumber, user.SystemAdmin))
                .then(() => {
                    setShowAddEditModal(false)
                    dispatch(fetchUser(match.params.userId))
                })
        }
    }

    const handleDelete = (user) => {
        if(user.id) {
            dispatch(removeUser(user.id))
                .then(() => {
                    setShowAddEditModal(false)
                    history.push("/users")
                })
        }
    }

    return <div>
        <ButtonBar>
            <Button as={Link} to={"/users"}>Users</Button>
            <Button onClick={()=>{
                setShowAddEditModal(true);
            }}>Redigera</Button>
        </ButtonBar>
        {fetchingUser && <UserSummary>
            Loading...
        </UserSummary>}
        {!fetchingUser && <UserSummary>
            <UserSummaryHeader>
                <h4>User #{user && user.id}</h4>
            </UserSummaryHeader>
            <div style={{display: "flex", marginTop: "1em"}}>
                <div>
                    <div>
                        <InfoLabel>Name:</InfoLabel> {user && (user.FirstName)} {user && (user.LastName)}
                    </div>
                    <div>
                        <InfoLabel>Sys.Admin:</InfoLabel> {user && user.SystemAdmin}
                    </div>
                </div>
                <div style={{marginLeft: "4em"}}>
                    <div>
                        <InfoLabel>Email:</InfoLabel> {user && user.Email}
                    </div>
                    <div>
                        <InfoLabel>Mobile:</InfoLabel> {user && user.MobileNumber}
                    </div>
                </div>
                <div style={{marginLeft: "4em"}}>
                    <div>
                        <InfoLabel>Updated:</InfoLabel> {user && user.updated_at}
                    </div>
                    <div>
                        <InfoLabel>Created:</InfoLabel> {user && user.created_at}
                    </div>
                </div>
            </div>
        </UserSummary>}
        <Nav variant="tabs">
            <Nav.Item>
                <Nav.Link active={true}>
                    Tenants
                </Nav.Link>
            </Nav.Item>
        </Nav>
        {!fetchingUser && <TabContent>
            <div>
                {user && <UserTenantConnections user={user.id} />}
            </div>
        </TabContent>}
        <AddEditUserModal show={showAddEditModal} editUser={user} onHide={hideAddEditModal} onSave={handleAddEditSave} onDelete={handleDelete}/>
    </div>
}

export default withRouter(UserView)